"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _InitialFilterParams = _interopRequireDefault(require("../constants/InitialFilterParams"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _Limits = _interopRequireDefault(require("../constants/Limits"));

var LOWER_LIMIT = _InitialFilterParams.default.get(_GoodFiltersAndPage.default.LIMIT);

var getLimits = function getLimits() {
  return [{
    text: _I18n.default.text('sortingBar.pageLimit.showNumber', {
      numberOfItems: _Limits.default.SMALL
    }),
    value: _Limits.default.SMALL
  }, {
    text: _I18n.default.text('sortingBar.pageLimit.showNumber', {
      numberOfItems: _Limits.default.LARGE
    }),
    value: _Limits.default.LARGE
  }];
};

var PageLimitPicker = _react.default.createClass({
  displayName: "PageLimitPicker",
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    className: _react.PropTypes.string,
    limit: _react.PropTypes.number.isRequired,
    onChange: _react.PropTypes.func.isRequired,
    total: _react.PropTypes.number.isRequired
  },
  updateLimit: function updateLimit(_ref) {
    var value = _ref.target.value;
    this.props.onChange((0, _defineProperty2.default)({}, _GoodFiltersAndPage.default.LIMIT, value));
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        limit = _this$props.limit,
        total = _this$props.total;

    if (total <= LOWER_LIMIT) {
      return null;
    }

    return _react.default.createElement(_UISelect.default, {
      className: className,
      buttonUse: "transparent",
      value: limit,
      searchable: false,
      options: getLimits(),
      onChange: this.updateLimit
    });
  }
});

var _default = PageLimitPicker;
exports.default = _default;
module.exports = exports.default;